import API, { baseURL } from './api';
import { getSucursalInfo, getUserInfo } from './auth';

// Client for sge_infantil_core's routes/gradebook.js (mounted at /api/gradebook).
// Uses the plain routes (POST /, GET /:sucursalId, PUT /:id/*) — these are the
// ones the real sge_infantil_web app actually calls (grep-verified across
// src/pages/grade/{create,list}/index.js); the "/with-period" variants exist
// on the backend but are dead code, never called by the real frontend.
export async function listGradebooks({ levelId, classId, subjectId, evaluationId, teacherId, year, period, sucursalId } = {}) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/gradebook/${id}`, { params: { levelId, classId, subjectId, evaluationId, teacherId, year, period } });
}

export async function createGradebook({ level, subject, evaluation, classroom, teacher, period, evaluationDate, degree, degreeLevel, sucursalId }) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/gradebook`, {
    sucursalId: id,
    level,
    subject,
    evaluation,
    classroom,
    teacher,
    period,
    evaluationDate,
    degree,
    degreeLevel,
  });
}

export async function setGrade(gradebookId, studentId, grade) {
  return API.put(`${baseURL}api/gradebook/${gradebookId}/grades`, { studentId, grade });
}

export async function finalizeGradebook(gradebookId, teacherNotes) {
  return API.put(`${baseURL}api/gradebook/${gradebookId}/finalize`, { teacherNotes });
}

export async function publishGradebook(gradebookId, notes) {
  return API.put(`${baseURL}api/gradebook/${gradebookId}/publish`, { publishedBy: getUserInfo()?.id, notes });
}

export async function requestChange(gradebookId, notes) {
  return API.put(`${baseURL}api/gradebook/${gradebookId}/change`, { publishedBy: getUserInfo()?.id, notes });
}

export async function authorizeChange(gradebookId, notes) {
  return API.put(`${baseURL}api/gradebook/${gradebookId}/authorize-change`, { authorizedBy: getUserInfo()?.id, notes });
}

// Backs the "Pautas" screen (ported from sge_infantil_web's
// src/pages/grade/pauta/index.js `getGradeBook`), which groups a level's
// gradebooks by subject instead of listing one row per evaluation like
// Lista de Notas does. The backend already does this grouping server-side —
// GET /api/gradebook/group/:sucursalId — computing one combined `status`
// per subject+turma (DRAFT/CHANGE beat FINALIZED, which beats an
// all-PUBLISHED group) instead of leaving it to the client.
export async function groupGradebooks({ levelId, classId, period, sucursalId } = {}) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/gradebook/group/${id}`, { params: { levelId, classId, period } });
}

// Every gradebook for a subject (across evaluations/turmas) — used to cross
// a subject+turma's evaluations against its gradebooks and surface missing
// grades in the Pautas expand row, same as the original screen's
// `computePautaSummary`.
export async function listGradebooksBySubject(subjectId, sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/gradebook/subject/${id}/${subjectId}`);
}

// Bulk-publishes every FINALIZED gradebook for a subject+turma in one call
// (PUT /api/gradebook/publish/:sucursalId/:subjectId/:classId) — the route
// the Pautas screen's "Publicar" button uses, as opposed to publishGradebook
// above which publishes a single evaluation's gradebook (used by Lista de
// Notas). The backend rejects the whole batch if any of them isn't
// FINALIZED yet.
export async function publishGradebooksBySubjectClass(subjectId, classId, notes, sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.put(`${baseURL}api/gradebook/publish/${id}/${subjectId}/${classId}`, {
    publishedBy: getUserInfo()?.id,
    notes,
  });
}
